import { tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import globalError from './globalError';
import estimateLoaded from './estimateLoaded';
import loaded from './loaded';
import loading from './loading';


export default (
  itemId,
  quantity,
  designId,
) => (dispatch) => {
  dispatch(loading());

  designBuilderApi
    .updateItemQuantity(designId, itemId, quantity)
    .then(response => dispatch(estimateLoaded(response.data)))
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
